import type { ReactNode } from 'react';

import { useBreakpoint } from '@polyai/ui/hooks/useBreakpoint';

import { LeftPanelContainer, VignetteOverlay } from './LeftPanel.styled';

type LeftPanelProps = {
  bgUrl: string;
  children?: ReactNode;
  withBlur?: boolean;
  withVignette?: boolean;
};

const LeftPanel = ({
  bgUrl,
  children,
  withBlur = false,
  withVignette = false,
}: LeftPanelProps) => {
  const isDesktop = useBreakpoint('sm');

  // Don't render the image on mobile to save bandwidth
  // The panel is hidden via CSS anyway, but this prevents the image download
  if (!isDesktop) {
    return null;
  }

  return (
    <LeftPanelContainer>
      <img
        alt=""
        src={bgUrl}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: withBlur ? 'blur(8px)' : undefined,
          transform: withBlur ? 'scale(1.02)' : undefined, // Prevent blur edge artifacts
        }}
      />
      {withVignette && <VignetteOverlay />}
      {children}
    </LeftPanelContainer>
  );
};

export default LeftPanel;
